import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type StripedRowsContainerProps = {
	className?: string;
	style?: React.CSSProperties;
	children: any;
	bgReverse?: boolean;
};

export const StripedRowsContainer = ({
	children,
	className,
	style,
	bgReverse,
}: StripedRowsContainerProps) => {
	return (
		<ul
			className={clsx(
				styles.stripedRowsContainer,
				bgReverse ? styles.oddRowBackground : styles.evenRowBackground,
				className,
			)}
			style={{ ...style }}
		>
			{children}
		</ul>
	);
};
